<div class="updater">
  <div class="updater__title">Доступно обновление</div>
  <button app-flat-button class="updater__button" color="secondary" type="button" (click)="update()">Обновить</button>
  <button app-icon-button class="close-btn" type="button" (click)="close()">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
